import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/de/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__de-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const QAPageJsonld = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  breadcrumb: 'Lemonade.com > Lemonade FAQ',
  name: 'Lemonade FAQ',
  image:
    'https://www.lemonade.com/assets/lemonade-share-image-ad9d7846f31685bfb4af89f018e4dd5d460f4e73768a8fd500bfc1f069ff853a.png',
  description:
    'FAQs on Lemonade Insurance, a property and casualty insurance company offering policies to renters and homeowners.',
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout },
  seo: {
    title: 'Hausrat & Privathafpflichtversicherung FAQ | Lemonade',
    metaTitle: 'Hausrat & Privathafpflichtversicherung FAQ | Lemonade',
    description:
      'Versicherungen können verwirrend sein, müssen es aber nicht!! Hier sind einige der häufigsten Fragen zu Lemonade - von der Hausrat bis hin zu dem, was unsere Privathaftpflichtversicherung abdeckt (und sogar, wie Versicherungsansprüche funktionieren!) Bonus? Du erfährst auch ein bisschen mehr über zusätzliche Deckungen und das Geschäftsmodell von Lemonade.',
    jsonld: [QAPageJsonld],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
